export default __webpack_public_path__ + "static/dimo-32f8fd7903c1e7ae251391b2808ca730.svg";